import { Component, Input, HostListener, OnInit } from '@angular/core';
import { ALIGN, ActionModel, ButtonStyleModel, CARD_SIZE, EventsService, FIT, LAYOUTPOSITION, TextPosition, ImageFit, showCaseType, logoSpeed, logoDirection, svgData } from 'simpo-component-library';
import { animationSpeed, animationType, aspectRatio, borderType, cardSize, carouselSpeed, contentAlignment, corners, flexWrapOptions, footerType, headerStyling, imageFit, logoBoxType, logoCarouselDirection, mapStyle, minHeight, navigationStyle, OverLay, productCardTheme, showCaseTypeArray, spacingType, textPosition, headlineanimationType, contentAnimation, processSectionStyle, backgroundAnimation, pricingStyleType, contentBackgroundType, gridStyle, logoPosition, componentStyles, menuType } from './style-editor.modal';
import { TemplateService } from 'src/app/services/template.service';
import { DividerListComponent } from '../divider-list/divider-list.component';
import { MediaSelectorComponent } from '../../popups/media-selector/media-selector.component';

@Component({
  selector: 'app-style-editor',
  templateUrl: './style-editor.component.html',
  styleUrls: ['./style-editor.component.scss']
})
export class StyleEditorComponent implements OnInit {
 @Input() style: any;
  @Input() content: any;
  @Input() componentId: any;
  @Input() action?: ActionModel;
  @Input() sectionType: string | null = null;
  @Input() sectionIndex: number = -1;

  imageFit = imageFit;
  aspectRatio = aspectRatio;
  corners = corners
  cardSize = cardSize;
  textPosition = textPosition
  headlineanimationType = headlineanimationType
  contentAnimation = contentAnimation
  animationSpeed = animationSpeed
  animationType = animationType
  spacingType = spacingType
  minHeight = minHeight
  flexWrapOptions = flexWrapOptions;
  headerStyling = headerStyling;
  borderType = borderType
  TextPosition = TextPosition
  ImageFit = ImageFit
  contentAlignment = contentAlignment
  footerType = footerType
  navigationStyle = navigationStyle
  mapStyle = mapStyle;
  productCardTheme = productCardTheme;
  showcasetype = showCaseTypeArray
  showCaseEnum = showCaseType;
  carouselSpeed = carouselSpeed
  carouselDirection = logoCarouselDirection
  componentStyles = componentStyles;
  carouselDirectionEnum = logoDirection
  logoBoxType = logoBoxType
  overLayValue = OverLay
  processSectionStyle = processSectionStyle
  backgroundAnimation = backgroundAnimation
  pricingStyleType = pricingStyleType
  contentBackgroundType = contentBackgroundType
  gridStyle = gridStyle
  logoPosition = logoPosition
  dividerList = svgData;
  menuType = menuType;

  openSections: Record<string, boolean> = {
    section: true,
    typography: true,
    tag: true,
    media: true,
    item: true,
    theme: true
  };

  toggleSection(key: string): void {
    this.openSections[key] = !this.openSections[key];
  }

  get currentFontFamily(): string {
    return document.documentElement.style.getPropertyValue('--website-font-family').trim() || 'Default';
  }

  // Slider related data
  max = 100;
  min = 0;
  rowMin = 3;
  showTicks = false;
  step = 1;
  maximumProduct = 20;
  maxElementInRow = 5;
  borderMax = 20;
  setContentPosition = ['Left', 'Right'];
  borderRadiusMax = 200;
  businessType: any;
  bDetails: any;

  svgData = svgData

  constructor(private eventEmitter: EventsService,
    private dialogSercvice: TemplateService) {
    this.screenSize()
    console.log(this.dividerList)
  }

  @HostListener('window:resize', ['$event'])
  screenSize(event?: any) {
    this.screenWidth = window.innerWidth
  }
  screenWidth: any;

  selectedDivider: any;
  ngOnInit(): void {
    this.selectedDivider = svgData[this.style?.devider?.deviderType];

    let bDetails = window.localStorage.getItem('bDetails') || '';
    if (bDetails) {
      this.bDetails = JSON.parse(bDetails);
      this.businessType = this.bDetails?.type;
    }
  }
  autoplayVideos() {
    if (this.style.autoPlay) {
      this.style.hoverPlay = false;
    }
  }
  toggleBackgroundImage() {
    this.eventEmitter.backgroundImageChangeCheck.emit({
      data: this.style.background,
      id: this.componentId
    });
    this.eventEmitter.colorOverlayChangeChecks.emit({
      id: this.componentId,
      data: this.style.background,
    });
  }
  showDummyCartItems() {
    // this.eventEmitter.showDummyCartItems.emit(this.style.cartItemsStyling);
  }
  changeTextAlignment(textAlign: ALIGN) {
    this.style.layout.align = textAlign;
    this.eventEmitter.alignmentChangeChecks.emit({ id: this.componentId, data: this.style.layout })
  }
  changeComponentStyle(type: string) {
    this.style.componentStyle = type;
  }
  changeImageStyle() {
    this.eventEmitter.imageStyleChangeChecks.emit({ id: this.componentId, style: this.style.image });
  }

  changeImageFit(type: string) {
    this.style.image.fit = type;
    this.changeImageStyle();
  }

  changeCorners(type: string) {
    this.style.corners = type;
    this.eventEmitter.cornerChangeChecks.emit({ id: this.componentId, size: this.style.corners })
  }

  changeSpacingHorizontal(type: string) {
    this.style.layout.spacingHorizontal = type;
    this.eventEmitter.spacingChangeChecks.emit({ id: this.componentId, data: this.style.layout });
  }

  changeCardSize(size: CARD_SIZE) {
    this.style.size = size;
    this.eventEmitter.cardSizeChangeChecks.emit({ id: this.componentId, size: this.style.size })
  }

  changeTextBackground() {
    this.eventEmitter.textBackgroundChangeChecks.emit({ id: this.componentId, textBackground: this.style.textBackground })
  }

  changeAnimationType() {
    this.eventEmitter.animationChangeChecks.emit({ id: this.componentId, data: this.style.animation })
  }

  toggleAnimation(event: any) {
    this.style.animation.type = event.target.checked ? 'left' : 'none';
    this.changeAnimationType();
  }

  changeAccentColor() {
    this.eventEmitter.colorOverlayChangeChecks.emit({
      id: this.componentId,
      data: this.style.background
    });
  }

  changeAnimationSpeed(speed: string) {
    this.style.animation.speed = speed;
    this.changeAnimationType()
  }
  changeSpacingTop(type: string) {
    this.style.layout.spacing.top = type;
    this.changeSpacingType();
  }

  changeSpacingBottom(type: string) {
    this.style.layout.spacing.bottom = type;
    this.changeSpacingType();
  }
  changeSpacingType() {
    // if (direction === 'top') {
    //   this.style.layout.spacing.top = value;
    // } else if (direction === 'bottom') {
    //   this.style.layout.spacing.bottom = value;
    // }
    this.eventEmitter.spacingChangeChecks.emit({ id: this.componentId, data: this.style.layout });
  }

  changeContentAnimation() {
    this.eventEmitter.contentAnimationChangeChecks.emit({ id: this.componentId, data: { contentAnimation: this.style.contentAnimation } })
  }


  changeMinHeight(height: FIT) {
    this.style.layout.fit = height;
    this.eventEmitter.spacingChangeChecks.emit({ id: this.componentId, data: this.style.layout })
  }
  changeWrapOption(wrap: string) {
    this.style.direction = wrap;
    // this.eventEmitter.wrapDirection.emit(this.componentId);
  }
  changeBorderStatus() {
    if (this.style.devider.display) {
      this.style.border.display = false
      this.eventEmitter.borderChangeChecks.emit({ id: this.componentId, data: this.style.border })
    }
  }

  changeBorder() {
    if (this.style.border.display)
      this.style.devider.display = false
    this.eventEmitter.borderChangeChecks.emit({ id: this.componentId, data: this.style.border })
  }

  changeBorderType(borderType: string) {
    this.style.border.type = borderType;
    this.eventEmitter.borderChangeChecks.emit({ id: this.componentId, data: this.style.border })
  }

  changeLayoutAlignment(value: LAYOUTPOSITION) {
    this.style.positionLayout.value = value;
    this.eventEmitter.postionLayoutChangeChecks.emit({ id: this.componentId, data: this.style.positionLayout })
  }

  changeContentAlignment() {
    this.eventEmitter.contentAlignmentChangeCheck.emit({ id: this.componentId, data: this.style.contentAlignment });
  }
  changeContentAlignmentItem(type: string) {
    this.style.contentAlignment = type;
    this.changeContentAlignment();
  }

  changeHeadingSpacing(type: string) {
    this.style.layout.headingSpacing = type;
    this.eventEmitter.spacingChangeChecks.emit({ id: this.componentId, data: this.style.layout });
  }

  openBackgroundColorEditor() {
    // if(this.screenWidth > 475){
    //   this.dialogSercvice.openDialog(BackgroundColorEditorComponent,'auto',
    //   '430px', {id: this.componentId, background: this.style.background, action: this.action});
    // }
    // if(this.screenWidth < 475){
    //   this.dialogSercvice.openDialog(BackgroundColorEditorComponent,'100vh',
    //   '430px', {id: this.componentId, background: this.style.background, action: this.action});
    // }
    this.dialogSercvice.secondaryEditor.emit({ data: { tab: 'BACKGROUND' } });
  }

  openButtonStyleEditor(buttonStyle: ButtonStyleModel, btnId: string) {
    // this.dialogSercvice.openDialog(ButtonStyleEditorComponent, 'auto',
    //   '430px', {id: this.componentId, btnId: btnId, buttonStyle: buttonStyle, color: this.style.background.accentColor});
    this.dialogSercvice.secondaryEditor.emit({ data: { tab: 'BUTTON_STYLE', buttonStyle: buttonStyle, btnId: btnId, backgroundInfo: this.style.background } });

  }
  openDividerList() {
    this.dialogSercvice.secondaryEditor.emit({ data: { tab: 'DIVIDER', data: this.style.devider } });
  }
  getFormattedText(text: string): string {
    return text.replaceAll("__", " + ").replaceAll("_", " ");
  }

  changeMapStyle() {
    this.eventEmitter.mapStyleChangeCheck.emit(this.style.mapStyle);
  }

  changeTextPosition() {
    if (this.style.textPosition != TextPosition.BELOW_IMAGE) {
      this.style.image.fit = ImageFit.Cover;
      this.changeImageStyle()
    }
  }

  changeDivider() {
    this.dialogSercvice.openDialog(DividerListComponent, 'auto', '430px', { data: this.style.devider })
    console.log(this.style.devider, this.style?.devider?.deviderType, this.dividerList[this.style?.devider?.deviderType]?.svg)
  }
  getBackgroundDirection(direction) {
    if (direction == 'DOWN') {
      return '180deg'
    }
    else if (direction == 'RIGHT') {
      return '90deg'
    } else if (direction == 'DIAGONAL_RIGHT') {
      return '45deg'
    }
    else {
      return '315deg'
    }
  }

  showImageStyles(): boolean {
    if (this.style.hasOwnProperty('image') && this.content?.image?.showImage === false)
      return false;
    else if (this.style.hasOwnProperty('image') || this.style.hasOwnProperty('borderLessImage') || this.style.hasOwnProperty('corners'))
      return true;
    else
      return false;
  }

  hasContentImage(): boolean {
    return !!(this.content?.image?.url || this.content?.image?.id);
  }

  updateColumns() {
    const header = this.content.productTableDataList[0];
    const currentColumns = header.length;
    const requiredColumns = this.content.numberOfColumns;

    // ➕ Add Columns
    if (requiredColumns > currentColumns) {

      const columnsToAdd = requiredColumns - currentColumns;

      for (let i = 0; i < columnsToAdd; i++) {

        const newColumnNumber = this.content.productTableDataList[0].length + 1;

        this.content.productTableDataList.forEach((row: any[], rowIndex: number) => {
          row.push({
            columnCell: newColumnNumber,
            value: rowIndex === 0 ? 'Heading' : 'Description'
          });
        });

      }
    }

    // ❌ Remove Columns
    else if (requiredColumns < currentColumns) {

      const columnsToRemove = currentColumns - requiredColumns;

      for (let i = 0; i < columnsToRemove; i++) {
        this.content.productTableDataList.forEach((row: any[]) => {
          if (row.length > 1) {
            row.pop();
          }
        });
      }
    }
  }

  updateRows() {
    const table = this.content.productTableDataList;
    const currentRows = table.length - 1; // excluding header

    // ➕ Add rows
    if (this.content.numberOfRows > currentRows) {
      const rowsToAdd = this.content.numberOfRows - currentRows;

      for (let i = 0; i < rowsToAdd; i++) {
        const newRow: any[] = [];

        for (let col = 1; col <= this.content.numberOfColumns; col++) {
          newRow.push({
            columnCell: col,
            value: `Column ${col}`
          });
        }

        table.push(newRow);
      }

      // ➖ Remove rows (keep header safe)
    } else if (this.content.numberOfRows < currentRows) {
      const rowsToRemove = currentRows - this.content.numberOfRows;

      for (let i = 0; i < rowsToRemove; i++) {
        if (table.length > 1) {
          table.pop();
        }
      }
    }
  }
  async updateBGImage(ev: any) {
    // const file = ev.srcElement.files[0];

    if (this.screenWidth > 475) {
      let dialog = this.dialogSercvice.openDialogWithData(
        MediaSelectorComponent,
        '90vh',
        '50%',
        { multiple: false }
      )
      dialog.afterClosed().subscribe(
        (res: any) => {
          this.style.background.image = res[0]?.assets[0]?.url;
          this.eventEmitter.backgroundImageChangeCheck.emit({ id: this.componentId, data: this.style.background })
        }
      )
    }
    if (this.screenWidth < 475) {
      let dialog = this.dialogSercvice.openDialogWithData(
        MediaSelectorComponent,
        '90vh',
        'auto',
        { multiple: false }
      )
      dialog.afterClosed().subscribe(
        (res: any) => {
          this.style.background.image = res[0].assets[0].url;
          this.eventEmitter.backgroundImageChangeCheck.emit({ id: this.componentId, data: this.style.background.image })
        }
      )
    }
  }
}
